import { type SxProps } from '@mui/material/styles';

export const styles = {
  root: {
    display: 'flex',
    minHeight: '100vh',
    height: '100vh',
    overflow: 'hidden',
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    marginLeft: '240px',
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    minWidth: 0,
    overflow: 'hidden',
  },
  /** Fills `main` so route content can use flex + minHeight 0 (kanban columns scroll inside). */
  outletWrap: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    minWidth: 0,
    overflow: 'auto',
  },
} satisfies Record<string, SxProps>;
